import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, headers: { "Content-Type": "application/json" } });

export const submitLead = (data) => api.post("/leads", data).then((r) => r.data);
export const submitPlanner = (data) => api.post("/planner", data).then((r) => r.data);

// Analytics tracking placeholder — safely no-ops until GA4/GTM/Pixel are wired.
export const track = (event, params = {}) => {
  try {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
    if (typeof window.gtag === "function") window.gtag("event", event, params);
    if (typeof window.fbq === "function") window.fbq("trackCustom", event, params);
    // eslint-disable-next-line no-console
    console.debug("[track]", event, params);
  } catch (e) {
    /* noop */
  }
};
